import { EnumStorageTransactionStatus } from './Generated';
import { SelectOption } from '@synqo/frontend-component-library';

// @ai-generated 2026-10-26T15:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const getEnumStorageTransactionStatusLabel = (value: EnumStorageTransactionStatus) => {
    switch (value) {
        case EnumStorageTransactionStatus.Effective:
            return 'Wirksam';
        case EnumStorageTransactionStatus.Cancelled:
            return 'Storniert';
        default:
            return 'Nicht definiert';
    }
};

export const enumStorageTransactionStatusOptions: SelectOption<EnumStorageTransactionStatus>[] = [
    {
        name: 'effective',
        label: getEnumStorageTransactionStatusLabel(EnumStorageTransactionStatus.Effective),
        value: EnumStorageTransactionStatus.Effective,
    },
    {
        name: 'cancelled',
        label: getEnumStorageTransactionStatusLabel(EnumStorageTransactionStatus.Cancelled),
        value: EnumStorageTransactionStatus.Cancelled,
    },
];
